import { missionLocationEntityName, missionPositionEntityName, } from '../../backend/config/classifiers';
import { missionEntityName } from '../../backend/features/mission/shared';
import { shiftEntityName, shiftParticipantEntityName, } from '../../backend/features/shift/shared';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
export function useMissionStorage() {
    return useStorageClient(missionEntityName);
}
export function useShiftStorage() {
    return useStorageClient(shiftEntityName);
}
export function useShiftParticipantStorage() {
    return useStorageClient(shiftParticipantEntityName);
}
export function useMissionPositionStorage() {
    return useStorageClient(missionPositionEntityName);
}
export function useMissionLocationStorage() {
    return useStorageClient(missionLocationEntityName);
}
